<div class="server-certificate" [ngClass]="{'routing-server-certificate': type === 'server'}">

  <div class="view-certificate">
    <arm-form-title>View Current Certificate</arm-form-title>
    <div class="settings-section">
      <div (click)="viewCurrentCertificate()" class="view-certificate-div">
      <span class="certificate-button">
      <span>View Certificate </span> <i class="fa fa-eye"></i>
      </span>
      </div>
    </div>
  </div>

  <arm-form (submitForm)="submit()" [buttonLabel]="'Generate'" [disableSubmit]="!canSubmit">
    <arm-form-title>Generate Certificate</arm-form-title>
    <div class="settings-section">
      <div class="certificate-inputs">
        <div class="right">
          <mat-form-field>
            <mat-label>Common Name [CN]</mat-label>
            <input [(ngModel)]="certificate.cn" matInput name="cn" required>
            <mat-error>
              CN is <strong>required</strong>
            </mat-error>
          </mat-form-field>

          <mat-form-field>
            <mat-label>Organizational Unit [OU]</mat-label>
            <input [(ngModel)]="certificate.ou" matInput name="ou">
          </mat-form-field>

          <mat-form-field>
            <mat-label>Company Name [O]</mat-label>
            <input [(ngModel)]="certificate.o" matInput name="o">
          </mat-form-field>


          <mat-form-field>
            <mat-label>Locality or city name [L]</mat-label>
            <input [(ngModel)]="certificate.l" matInput name="l">
          </mat-form-field>

          <mat-form-field>
            <mat-label>State [ST]</mat-label>
            <input [(ngModel)]="certificate.st" matInput name="st">
          </mat-form-field>

          <mat-form-field>
            <mat-label>County code [C]</mat-label>
            <input [(ngModel)]="certificate.c" matInput name="c">
          </mat-form-field>

          <ac-input-container label="Key Algorithm:">
            <ac-select [acModel]="certificate.keyAlg"
                       (acModelChange)="certificate.keyAlg = $event; onKeyAlgorithmChange($event)"
                       [attr.alternativeName]="'certificate.keyAlg'"
                       [items]="keyAlgorithmOptions">
            </ac-select>
          </ac-input-container>

          <ac-input-container label="Private Key Size:">
            <ac-select [acModel]="certificate.keySize"
                       (acModelChange)="certificate.keySize = $event"
                       [attr.alternativeName]="'certificate.keySize'"
                       [items]="keySizeOptions">
            </ac-select>
          </ac-input-container>

          <ac-input-container label="Signature Algorithm:">
            <ac-select [acModel]="certificate.signAlg"
                       (acModelChange)="certificate.signAlg = $event"
                       [attr.alternativeName]="'certificate.signAlg'"
                       [items]="signatureAlgorithmOptions">
            </ac-select>
          </ac-input-container>
        </div>

        <div class="left">
          <mat-form-field class="fullWidth">
            <mat-label>Validity (days)</mat-label>
            <input matInput [(ngModel)]="certificate.validity" type="number" min="1"
                   max="3000" name="validity" required>
            <mat-error>
              Validity is <strong>required</strong>, value range between 1 to 3000
            </mat-error>
          </mat-form-field>

          <ac-input-container label="SAN Email:">
            <ac-select class="single-row"
                       [acModel]="certificate.sanEmail"
                       (acModelChange)="certificate.sanEmail = $event"
                       [attr.alternativeName]="'certificate.sanEmail'"
                       [multiple]="true"
                       [bindValue]="null"
                       [addCustomTags]="true"
                       [combinedMode]="true"
                       [allowClear]="true">
            </ac-select>
          </ac-input-container>
          <ac-input-container label="SAN URI:">
            <ac-select class="single-row"
                       [acModel]="certificate.sanURI"
                       (acModelChange)="certificate.sanURI = $event"
                       [attr.alternativeName]="'certificate.sanURI'"
                       [multiple]="true"
                       [addCustomTags]="true"
                       [bindValue]="null"
                       [combinedMode]="true"
                       [allowClear]="true">
            </ac-select>
          </ac-input-container>
          <ac-input-container label="SAN DNS:">
            <ac-select class="single-row"
                       [acModel]="certificate.sanDNS"
                       (acModelChange)="certificate.sanDNS = $event"
                       [attr.alternativeName]="'certificate.sanDNS'"
                       [multiple]="true"
                       [bindValue]="null"
                       [addCustomTags]="true"
                       [combinedMode]="true"
                       [allowClear]="true">
            </ac-select>
          </ac-input-container>
          <ac-input-container label="SAN IP:">
            <ac-select class="single-row"
                       [acModel]="certificate.sanIP"
                       (acModelChange)="certificate.sanIP = $event"
                       [attr.alternativeName]="'certificate.sanIP'"
                       [multiple]="true"
                       [bindValue]="null"
                       [addCustomTags]="true"
                       [combinedMode]="true"
                       [allowClear]="true">
            </ac-select>
          </ac-input-container>

          <div class="property-with-critical-option">
            <ac-input-container label="Key Usage" class="ac-select-with-critical">
              <ac-select class="single-row"
                         [acModel]="certificate.keyUsage"
                         (acModelChange)="certificate.keyUsage = $event"
                         [attr.alternativeName]="'certificate.keyUsage'"
                         [multiple]="true"
                         [items]="keyUsageOptions">
              </ac-select>
            </ac-input-container>
            <div class="critical">
              <mat-checkbox name="keyUsageCritical" color="primary" [(ngModel)]="certificate.keyUsageCritical">Critical</mat-checkbox>
            </div>
          </div>

          <div class="property-with-critical-option">
            <ac-input-container label="Extended Key Usage" class="ac-select-with-critical">
              <ac-select class="single-row"
                         [acModel]="certificate.extendedkeyUsage"
                         (acModelChange)="certificate.extendedkeyUsage = $event"
                         [attr.alternativeName]="'certificate.extendedkeyUsage'"
                         [multiple]="true"
                         [items]="extendedKeyUsageOptions">
              </ac-select>
            </ac-input-container>
            <div class="critical">
              <mat-checkbox name="extendedKeyUsageCritical" color="primary" [(ngModel)]="certificate.extendedKeyUsageCritical">Critical</mat-checkbox>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="settings-section">
      <mat-radio-group class="radio-option" [(ngModel)]="certificate.generateType"
                       [ngModelOptions]="{standalone: true}">
        <div class="radio-options">
          <mat-radio-button color="primary" [value]="'privateKeyAndSelfSigned'">Generate Private Key and Self-Signed Certificate</mat-radio-button>
          <mat-radio-button color="primary" [value]="'replacePrivateKeyAndSelfSigned'">Generate and Replace Private Key and Self-Signed Certificate</mat-radio-button>
          <mat-radio-button color="primary" [value]="'privateKeyAndCsr'">Generate Private Key and CSR</mat-radio-button>
        </div>
      </mat-radio-group>
    </div>
  </arm-form>


  <arm-form (submitForm)="uploadCertificateFiles()" [buttonLabel]="'Upload'" [disableSubmit]="!uploadCertificate.keyStoreFile">
    <arm-form-title>Load Certificate</arm-form-title>
    <div class="settings-section">
      <div class="certificates-upload">
        <div class="keystore">
          <ac-input-container label="Load KeyStore">
            <ac-file-picker #keyStore
                            alternativeName="uploadCertificate.keyStoreFile"
                            (acChanged)="onKeyStoreFileChange($event)"
                            [filePickerButtonText]="'Browse'"
                            [clearable]="true"
                            [fileTypeAllowed]="['jks']"
                            [ngDisabled]="pfx.fileName">
            </ac-file-picker>
          </ac-input-container>

          <ac-input-container label="Load CSR Response">
            <ac-file-picker #csr
                            alternativeName="uploadCertificate.csrfile"
                            (acChanged)="onCsrFileChange($event)"
                            [filePickerButtonText]="'Browse'"
                            [displayTextBox]="true"
                            [clearable]="true"
                            [fileTypeAllowed]="['p7b']"
                            [ngDisabled]="pfx.fileName">
            </ac-file-picker>
          </ac-input-container>

          <mat-form-field floatLabel="always">
            <mat-label>Password</mat-label>
            <input type="password" [(ngModel)]="uploadCertificate.passwordKS" matInput name="password" placeholder="Use default password"
                   [disabled]="!keyStore.fileName">
            <mat-hint>Only change if keyStore was not generated using ARM</mat-hint>
          </mat-form-field>

          <mat-form-field *ngIf="this.uploadCertificate.csrfile" floatLabel="always" class="upload-csr">
            <mat-label>Alias</mat-label>
            <input [(ngModel)]="uploadCertificate.alias" matInput name="alias" placeholder="server">
            <mat-hint>Only change if keyStore was not generated using ARM</mat-hint>
          </mat-form-field>
        </div>
        <div class="pfx">
          <ac-input-container label="Load PFX file">
            <ac-file-picker #pfx
                            alternativeName="uploadCertificate.keyStoreFile"
                            (acChanged)="onKeyStoreFileChange($event)"
                            [filePickerButtonText]="'Browse'"
                            [clearable]="true"
                            [fileTypeAllowed]="['pfx', 'p12']"
                            [ngDisabled]="keyStore.fileName">
            </ac-file-picker>
          </ac-input-container>

          <mat-form-field floatLabel="always">
            <mat-label>Password</mat-label>
            <input type="password" [(ngModel)]="uploadCertificate.passwordPfx" [disabled]="!pfx.fileName"
                   [required]="pfx.fileName" matInput name="password-pfx">
            <mat-hint>PFX Passphrase</mat-hint>
          </mat-form-field>
        </div>
      </div>
    </div>
  </arm-form>


</div>
